import React, { useState } from 'react';
import { MDBSideNavCollapse, MDBSideNavItem, MDBSideNavLink, MDBCheckbox } from 'mdb-react-ui-kit';

const Party = ({ userSelectedParty, setUserSelectedParty, availableParties }) => {
    const [collapse, setCollapse] = useState(false);

    // Convert availableParties to array if it's not already
    const availablePartiesArray = Array.isArray(availableParties) ? availableParties : [];

    const parties = [
        { id: 'CONSTITUTIONAL', label: 'Constitutional' },
        { id: 'DEMOCRAT', label: 'Democrat' },
        { id: 'GREEN', label: 'Green' },
        { id: 'INDEPENDENT', label: 'Independent' },
        { id: 'LIBERTARIAN', label: 'Libertarian' },
        { id: 'REPUBLICAN', label: 'Republican' },
        { id: 'REFORM', label: 'Reform' }
    ].filter(party => availablePartiesArray.includes(party.id));

    const handlePartyChange = (partyId) => {
        setUserSelectedParty(prev => {
            if (prev?.includes(partyId)) {
                return prev.filter(id => id !== partyId);
            } else {
                return [...(prev || []), partyId];
            }
        });
    };

    return (
        <MDBSideNavItem>
            <MDBSideNavLink icon='angle-down' shouldBeExpanded={collapse} onClick={() => setCollapse(!collapse)}>
                Party
            </MDBSideNavLink>
            <MDBSideNavCollapse open={collapse}>
                <div className="p-3">
                    {parties.map(party => (
                        <div 
                            key={party.id} 
                            className="d-flex align-items-center mb-2"
                        >
                            <MDBCheckbox
                                name={party.id}
                                id={party.id}
                                label={party.label}
                                checked={userSelectedParty?.includes(party.id) || false}
                                onChange={() => handlePartyChange(party.id)}
                            />
                        </div>
                    ))}
                </div>
            </MDBSideNavCollapse>
        </MDBSideNavItem>
    );
};

export default Party;
